import styled from "@emotion/styled"

export type StyledProps = {
  isMobile?: boolean
  isLandscape?: boolean
  noPad?: boolean
}

export const Root = styled.div<StyledProps>`
  padding: ${({ isLandscape, noPad }) =>
    noPad ? "0" : isLandscape ? "0rem" : "0.5rem 0"};
`

export const ImageLogo = styled.object<StyledProps>`
  height: 3rem;
  max-width: 100%;
`
